import type { Meta } from "../types";

/**
 * Freshness strip for a source-backed panel: when the data was last fetched,
 * plus the backend's note when it has one. Which store or cache the bytes came
 * from is plumbing, not information (Vitalik, 2026-08-21), so no source or
 * cache badges here — the timestamp already says how fresh the numbers are.
 */
export default function MetaBadge({
  meta,
  fetchedAt,
  className = "",
}: {
  meta?: Meta | null;
  fetchedAt?: number | null;
  className?: string;
}) {
  const time = meta?.fetched_at
    ? new Date(meta.fetched_at)
    : fetchedAt
      ? new Date(fetchedAt)
      : null;

  return (
    <div className={`flex flex-wrap items-center gap-1.5 text-micro text-muted ${className}`}>
      {time && (
        <span>
          оновлено{" "}
          <span className="jv-num">
            {time.toLocaleTimeString("uk-UA", { hour: "2-digit", minute: "2-digit" })}
          </span>
        </span>
      )}
      {meta?.note && (
        <span className="max-w-[28rem] truncate" title={meta.note}>
          {meta.note}
        </span>
      )}
    </div>
  );
}
